/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, Fragment, ReactNode, useRef } from "react";
import { useFormatMsg } from "src/hooks/useFormatMsg";
import { useAuthentication } from "src/store/login/hooks/useSelectors";
import { useAppVersion } from "src/store/personalization/useSelectors";
import { useIsMobile } from "../../../../hooks/viewport/useViewportCategory";
import FlowioErrorBoundary from "../../../atoms/FlowioErrorBoundary";
import withViewportInfoHOC, {
  WithViewportInfoHOC,
} from "../../../enhancers/withViewportInfo/withViewportInfoHOC";
import NavMenu from "../../../organisms/NavMenu";
import { ScrollContainerContextProvider } from "../../../providers/ScrollContainerContextProvider";
import {
  footerCss,
  innerContainerCss,
  MainContainer,
  mainContainerWrapperCss,
} from "./styles";

type Props = {
  hideLogin: boolean;
  children: ReactNode;
};

const PageLayout: FC<Props> = ({ children, hideLogin }) => {
  const isMobile = useIsMobile();
  const formatMsg = useFormatMsg();
  const currentYear = new Date().getFullYear();
  const { user } = useAuthentication();
  const appVersion = useAppVersion();
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <Fragment>
      <FlowioErrorBoundary>
        {user && <NavMenu hideLogin={hideLogin} />}
      </FlowioErrorBoundary>
      <FlowioErrorBoundary>
        <div
          css={mainContainerWrapperCss}
          id="flowio-container"
          ref={containerRef}
        >
          <ScrollContainerContextProvider value={{ ref: containerRef }}>
            <MainContainer data-cy="main-container">
              <div css={innerContainerCss}>{children}</div>
              <footer css={footerCss}>
                <small>{`${currentYear} Popron Systems a.s.`}</small>
                {appVersion && (
                  <small>
                    {formatMsg("personalization.version", {
                      version: appVersion,
                    })}
                  </small>
                )}
              </footer>
            </MainContainer>
          </ScrollContainerContextProvider>
        </div>
      </FlowioErrorBoundary>
    </Fragment>
  );
};

export default withViewportInfoHOC(PageLayout);
export type PageLayoutProps = WithViewportInfoHOC<Props>;
